import { render, staticRenderFns } from "./Func0Detalhe.vue?vue&type=template&id=216ba1cc"
import script from "./Func0Detalhe.vue?vue&type=script&lang=js"
export * from "./Func0Detalhe.vue?vue&type=script&lang=js"
import style0 from "./Func0Detalhe.vue?vue&type=style&index=0&id=216ba1cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports